import React, { useState, useContext, useEffect, useRef } from 'react'
import { NavLink, useHistory, useLocation } from 'react-router-dom'
import { LOGO, SITE_NAME } from '@/utils'
import { Link } from 'react-router-dom'
import { useFormik } from 'formik'
import QRCode from 'react-qr-code'

import {
    Badge,
    Button,
    ClickAwayListener,
    Divider,
    IconButton,
    ListItem,
    SwipeableDrawer,
} from '@material-ui/core'
import AuthContext from '@/product/context/auth/authContext'
import CommonContext from '@/product/context/common/commonContext'
import CustomCommonContext from '../../../../custom/context/common/commonContext'
import CartContext from '@/product/context/cart/cartContext'
import AlertContext from '@/product/context/alert/alertContext'
import * as Yup from 'yup'
import { handleRedirectInternal, useCustomMediaQuery } from '@/product/common/components'
import './Header.css'
import AutopltContext from '@/product/context/autopilot/autopltContext'
import UserContext from '@/product/context/user/userContext'
import ProductContext from '@/product/context/product/productContext'
import BidHistory from '@/custom/components/organisms/BidHistory'
import LanguageSwitch from '../LanguageSwitch'
import BuynowContext from '@/product/context/buynow/buynowContext'
import PayContext from '@/product/context/payment/payContext'
import CreditContext from '@/product/context/credit/creditContext'
import OfflineContext from '@/product/context/offline/offlineContext'
import Loaders from '../Loaders'
import { Popover } from '@material-ui/core'
import { mapData } from '@/product/common/components'
import Nav from '@/custom/components/atoms/Nav'
import NavItem from '@/custom/components/atoms/NavItem'
import CustomSelect from '@/product/components/atoms/Inputs/CustomSelect'
import { menuList, authList, pageOptions } from '@/utils/common'
import Dialog from '@/product/components/organisms/Dialog'
import PrimaryButton from '@/product/components/atoms/PrimaryButton'
import { BarcodeDetector } from 'barcode-detector'
import { imgPreview } from '@/product/common/cropper/imgPreview'
import BarCodeScan from '@/custom/components/organisms/BarCodeScan'
import MobileHeader from './MobileHeader'
import InvoiceContext from '@/product/context/invoice/invoiceContext'
import StripeCardContext from '@/product/context/stripe/card/cardContext'
import CustomDialog from '../../organisms/CustomDialog'
import openSocket from 'socket.io-client'
import { Autocomplete } from './autocomplete'
import { getAlgoliaResults } from '@algolia/autocomplete-js'
import algoliasearch from 'algoliasearch'
import { socket } from '@/product/common/socket'
import Login from '@/views/Login/login'
import CustomDrawer from '../CustomDrawer'
import Registration from '@/views/Registration'
import SignContext from '@/custom/context/signContext'
import LocationSelector from '@/custom/common/LocationSelector'
import NotesContext from '@/product/context/notes/notesContext'
import ForgotPassword from '@/views/ForgotPassword'
import ResetPassword from '@/views/ResetPassword'
import ReactPlayer from 'react-player'

const Header = () => {
    const iOS = process.browser && /iPad|iPhone|iPod/.test(navigator.userAgent)
    const authContext = useContext(AuthContext)
    const alertContext = useContext(AlertContext)
    const commonContext = useContext(CommonContext)
    const customCommonContext = useContext(CustomCommonContext)
    const productContext = useContext(ProductContext)
    const payContext = useContext(PayContext)
    const cartContext = useContext(CartContext)
    const creditContext = useContext(CreditContext)
    const offlineContext = useContext(OfflineContext)
    const userContext = useContext(UserContext)
    const invoiceContext = useContext(InvoiceContext)
    const autopltContext = useContext(AutopltContext)
    const buynowContext = useContext(BuynowContext)
    const [cityName, setCityName] = useState('')
    const [isMuted, setIsMuted] = useState(true)
    const { setAlert } = alertContext
    const {
        user,
        isAuthenticated,
        loadPendingCount,
        isAdmin,
        cartCount,
        logout,
        switchUser,
        loadUser,
        login,
        responseStatus: responseStatusAuth,
        clearResponse: clearResponseAuth,
    } = authContext

    const {
        get_all_card_details,
        getAllStripeCards,
        responseStatus: responseStatusCard,
        clearResponse: clearResponseCard,
    } = useContext(StripeCardContext)

    const [state, setState] = useState({
        right: false,
        top: false,
    })

    const formik = useFormik({
        initialValues: {
            user: '',
        },
        onSubmit: (values) => {},
    })

    const history = useHistory()

    const [anchormenu, setanchormenu] = useState(null)
    const [anchormenubar, setanchormenubar] = useState(null)
    const [anchorcart, setanchorcart] = useState(null)
    const [isStreaming, setIsStreaming] = useState(false)
    const [showPopup, setShowPopup] = useState(false)
    const [qrCodePopup, setQrCodePopup] = useState(false)
    const [isUserLoaded, setIsUserLoaded] = useState(false)
    const [disable, setDisable] = useState(false)
    const [imageFile, setImageFile] = useState('')
    const [openLocation, setOpenLocation] = useState(false)
    const [openSearch, setOpenSearch] = useState(false)
    const barcodeDetector = new BarcodeDetector()
    const [fileUploaded, setFileUploaded] = useState('')
    const [source, setSource] = useState('')
    const [menuDrawerOpen, setMenuDrawerOpen] = useState(false)
    const videoRef = useRef(null)
    const canvasRef = useRef(null)
    let params = new URLSearchParams(window.location.search)
    useEffect(() => {
        window.scrollTo(0, 0)
    }, [])

    const [showIntroPopup, setShowIntroPopup] = useState(() => {
        return sessionStorage.getItem('showIntroPopup') !== 'false'
    })
    const [videoPopup, setVideoPopup] = useState(false)
    const [videoLink, setVideoLink] = useState('')

    const {
        search_alldashboardproducts,
        getAllDashboardProducts,
        getAllSearchProducts,
        search_allproducts: searchProduct,
        responseStatus: responseStatusProduct,
        clearResponse: clearResponseProduct,
    } = productContext
    const { responseStatus: responseStatusPayment, clearResponse: clearResponsePayment } =
        payContext

    const { responseStatus: responseStatusCart, clearResponse: clearResponseCart } = cartContext

    const {
        responseStatus: responseStatusUser,
        clearResponse: clearResponseUser,
        updateProfile,
        changeUserStatus,
        forgotPassword,
    } = userContext
    const { responseStatus: responseStatusInvoice, clearResponse: clearResponseInvoice } =
        invoiceContext
    const { responseStatus: responseStatusCredit, clearResponse: clearResponseCredit } =
        creditContext

    const { responseStatus: responseStatusOffline, clearResponse: clearResponseOffline } =
        offlineContext

    const { responseStatus: responseStatusAutoPlt, clearResponse: clearResponseAutoPlt } =
        autopltContext

    const { responseStatus: responseStatusBuyNow, clearResponse: clearResponseBuyNow } =
        buynowContext

    const { responseStatus: responseStatusNotes, clearResponse: clearResponseNotes } =
        useContext(NotesContext)

    const { searchValue, setSearchValue, isLoading } = commonContext
    const {
        setCurrentMembership,
        allBiddingPlan,
        membership,
        getGlobalVariable,
        allLocations,
        configVariables,
        allHeaderMenus,
        allConfigurationVariables,
    } = customCommonContext

    const [locationData, setLocationData] = useState([])
    const [headerMenus, setHeaderMenus] = useState([])
    const [searchText, setSearchText] = useState('')
    const [scanToggle, setScanToggle] = useState(false)
    const [search, setSearch] = useState({
        auctionBuynowGrouped: true,
        orderby: 'crt.cart_id,desc',
    })
    const [selectedValue, setSelectedValue] = useState('')
    const [watchCount, setWatchCount] = useState(0)
    const [toggleDisconnectDialog, setToggleDisconnectDialog] = useState(false)

    const [socketDisconnect, setSocketDisconnect] = useState(false)
    const {
        loginPopup,
        handleLoginPopup,
        registerPopup,
        handleRegisterPopup,
        handleForgotPasswordPopup,
        forgotPasswordPopup,
    } = useContext(SignContext)

    const userRef = useRef(user?.id)

    // Sets user refrences on page load
    useEffect(() => {
        userRef.current = user?.id
    })

    const changeDisconnectDialogStatus = () => {
        refreshPage()

        setToggleDisconnectDialog(!toggleDisconnectDialog)
    }

    useEffect(() => {
        if (socket) {
            socket.on('connect', () => {
                // setSocketDisconnect(false)
            })
            socket.on('disconnect', () => {
                setToggleDisconnectDialog(true)
                // setSocketDisconnect(true)
            })
        }
    }, socket)

    const switch_user = [
        {
            placeholder: 'Switch User',
            class: 'col-12 pl-0 switchUserDD',
            type: 'select',
            variant: 'standard',
            options: [
                { value: 'user1', show: 'User-Seller' },
                { value: 'user2', show: 'User-Buyer' },
            ],
            name: 'user',
            formik: formik,
        },
    ]
    const handletoggleSearch = () => setOpenSearch(!openSearch)

    const handleLocation = () => setOpenLocation(!openLocation)
    const [locationName, setLocationName] = useState('Select Location')
    useEffect(() => {
        getGlobalVariable()
    }, [])
    useEffect(() => {
        if (formik.values.user) {
            if (formik.values.user === 'user1') {
                login({
                    email: 'abdul.auctionsoftware@gmail.com',
                    password: '12345678',
                })
            } else if (formik.values.user === 'user2') {
                login({
                    email: 'sara@auctionsoftware.com',
                    password: '12345678',
                })
            }
        }
        if (!isAuthenticated) {
            formik.values.user = ''
        }
    }, [formik.values.user, isAuthenticated])

    const formikSearch = useFormik({
        initialValues: {
            limit: 10,
            page: 1,
            orderby: 'p.date_closed,asc',
            order: '',
            auctionView: 'Grid',
            filters: {},
            action: 'watchlist',
        },
    })

    const watchlistFilter = {
        table: 'watchlists',
        field: 'w.id',
        havingCount: true,
        aliasName: 'watchlist',
        extraField: '',
        filters: {
            paid: {
                value: '0',
                type: 'in',
                field: 'w.is_delete',
            },
            active: {
                value: 'open',
                type: 'in',
                field: 'p.market_status',
            },
        },
        tableJoins: [
            {
                baseTable: 'projects',
                joinType: 'inner',
                baseJoinField: 'id',
                connectJoinField: 'project_id',
            },
        ],
    }

    const buyNowFilter = {
        table: 'cart_temp',
        field: 'cart_id',
        havingCount: true,
        extraField: '',
        filters: {
            paid: {
                value: '0',
                type: 'in',
                field: 'crt.paid',
            },
            market_status: {
                value: ['open', 'sold', 'closed', 'relisted'],
                type: 'array',
                field: 'p.market_status',
            },
        },
        tableJoins: [
            {
                baseTable: 'projects',
                joinType: 'inner',
                baseJoinField: 'id',
                connectJoinField: 'project_id',
            },
        ],
    }

    const bidsFilter = {
        table: 'bids',
        field: 'b.id',
        extraField: '',
        havingCount: true,
        aliasName: 'bids',
        uniqueFieldCount: 'b.project_id',
        filters: {
            paid: {
                value: '0',
                type: 'in',
                field: 'b.declined',
            },
            active: {
                value: 'open',
                type: 'in',
                field: 'p.market_status',
            },
        },
        tableJoins: [
            {
                baseTable: 'projects',
                joinType: 'inner',
                baseJoinField: 'id',
                connectJoinField: 'project_id',
            },
        ],
    }

    const setDecodedBarcode = (data) => {
        setSearchText(data)
        if (data && data !== '') {
            getAllSearchProducts(
                {
                    limit: 3,
                    page: 1,
                    orderby: 'p.id, desc',
                    order: '',
                    filters: {
                        product_id: {
                            value: data,
                            type: 'like',
                            field: 'p.id,p.item_id',
                        },
                    },
                    market_status: ['open'],
                },
                'scan_lot',
            )
        }
    }

    useEffect(() => {
        if (searchProduct && searchProduct.from == 'scan_lot') {
            if (searchProduct.records.length) {
                handleRedirectInternal(history, `product-view/${searchProduct.records[0].id}`)
            } else {
                setAlert(
                    'No matching products found for this barcode. Please try again or search manually.',
                    'error',
                )
                setSearchText('')
                setScanToggle(false)
                clearResponseProduct()
            }
        }
    }, [searchProduct])

    useEffect(() => {
        if (isAuthenticated) {
            // getSkyflowCredit()
            if (user && user.stripe_id) {
                getAllStripeCards({
                    account_id: process.env.REACT_APP_STRIPE_ACCOUNT,
                    customer_id: user.stripe_id,
                    object: 'card',
                })
            }

            if (user) {
                if (user.membership) {
                    if (allBiddingPlan && allBiddingPlan.length) {
                        let activePlan = allBiddingPlan.filter(
                            (value) => value.type === user.membership,
                        )
                        if (activePlan.length) {
                            setCurrentMembership(activePlan[0])
                        } else {
                            setCurrentMembership('')
                        }
                    }
                }
            }
        }
    }, [isAuthenticated, user, allBiddingPlan])

    useEffect(() => {
        if (
            responseStatusUser?.from === 'locationUpdate' &&
            responseStatusUser?.status === 'success'
        ) {
            loadUser()
            clearResponseUser()
        }
    }, [responseStatusUser])

    useEffect(() => {
        if (allLocations.length) {
            let dropValues = allLocations
                .filter((data) => data.active == 1)
                .map((location) => {
                    let locationChanged = {}
                    locationChanged.show = `${location.name}`
                    locationChanged.value = location.id
                    return locationChanged
                })
            let newArray = { show: 'Select Location', value: '' }
            setLocationData([newArray, ...dropValues])
        } else {
            setLocationData([])
        }
    }, [allLocations])

    const handleCapture = (target) => {
        if (target.files) {
            if (target.files.length !== 0) {
                const file = target.files[0]
                const newUrl = URL.createObjectURL(file)
                setSource(newUrl)
            }
        }
    }

    const handleRemoveImage = () => {
        setSource('')
    }

    const startCamera = async () => {
        try {
            const stream = await navigator.mediaDevices.getUserMedia({ video: true })
            videoRef.current.srcObject = stream
            setIsStreaming(true)
        } catch (error) {
            console.error('Error accessing camera:', error)
        }
    }
    const stopCamera = () => {
        const stream = videoRef.current.srcObject
        const tracks = stream.getTracks()

        tracks.forEach((track) => track.stop())

        videoRef.current.srcObject = null
        setIsStreaming(false)
    }

    const handleListSearch = () => {
        localStorage.setItem('clearSearch', true)
    }

    const takePhoto = () => {
        const video = videoRef.current
        const canvas = canvasRef.current
        const context = canvas.getContext('2d')

        // Set the canvas size to match the video stream
        canvas.width = video.videoWidth
        canvas.height = video.videoHeight

        // Draw the current frame from the video onto the canvas
        context.drawImage(video, 0, 0, canvas.width, canvas.height)

        // Convert the canvas content to a data URL representing the image
        const photoDataUrl = canvas.toDataURL('image/png')
    }

    const handleLink = (data) => {
        handleRedirectInternal(history, data)
    }

    useEffect(() => {
        // if (responseStatusUser) {
        //     setAlert(responseStatusUser.message, responseStatusUser.status)
        //     clearResponseUser()
        // }
        if (responseStatusProduct) {
            // setAlert(responseStatusProduct.message, responseStatusProduct.status)
            if (
                responseStatusProduct?.status === 'success' &&
                (responseStatusProduct.from === 'addWatchlist' ||
                    responseStatusProduct.from === 'removeWatchlist')
            ) {
                loadPendingCount(watchlistFilter, 'watchlistCount')
            }
            clearResponseProduct()
        }
        // if (responseStatusAutoPlt) {
        //     setAlert(responseStatusAutoPlt.message, responseStatusAutoPlt.status)
        //     clearResponseAutoPlt()
        // }
        // if (responseStatusAuth) {
        //     setAlert(responseStatusAuth.message, responseStatusAuth.status)
        //     clearResponseAutoPlt()
        // }
        if (responseStatusInvoice) {
            setAlert(responseStatusInvoice.message, responseStatusInvoice.status)
            clearResponseInvoice()
        }
        if (responseStatusBuyNow) {
            setAlert(responseStatusBuyNow.message, responseStatusBuyNow.status)
            if (
                (responseStatusBuyNow.from === 'customAddToCart' ||
                    responseStatusBuyNow.from === 'cartchange' ||
                    responseStatusBuyNow.from === 'addToCart') &&
                responseStatusBuyNow.status === 'success'
            ) {
                loadPendingCount(buyNowFilter, 'buynowCount')
            }
            clearResponseBuyNow()
        }

        if (responseStatusNotes) {
            if (responseStatusNotes?.from === 'notesAction') {
                setAlert(responseStatusNotes.message, responseStatusNotes.status)
            }
            clearResponseNotes()
        }
        // if (responseStatusPayment) {
        //     setAlert(responseStatusPayment.message, responseStatusPayment.status)
        //     clearResponsePayment()
        // }
        // if (responseStatusCart) {
        //     setAlert(responseStatusCart.message, responseStatusCart.status)
        //     clearResponseCart()
        // }
        // if (responseStatusCredit) {
        //     setAlert(responseStatusCredit.message, responseStatusCredit.status)
        //     clearResponseCredit()
        // }
        // if (responseStatusOffline) {
        //     setAlert(responseStatusOffline.message, responseStatusOffline.status)
        //     clearResponseOffline()
        // }
    }, [
        responseStatusProduct,
        responseStatusAutoPlt,
        responseStatusAuth,
        responseStatusBuyNow,
        responseStatusPayment,
        responseStatusCart,
        responseStatusCredit,
        responseStatusInvoice,
        responseStatusOffline,
        responseStatusNotes,
    ])

    useEffect(() => {
        if (responseStatusUser) {
            if (
                responseStatusUser.status === 'success' &&
                responseStatusUser.from === 'userStatusUpdated'
            ) {
                if (responseStatusUser.message === 'Email Exists') {
                    setShowPopup(false)
                    setDisable(false)
                    forgotPassword({ email: formikUser.values.email })
                    localStorage.setItem('user_added', 1)
                    // handleRedirectInternal(history, 'login')
                    handleLoginPopup()
                } else {
                    setShowPopup(false)
                    setDisable(false)
                    setAlert('Please check your email to login', 'success')
                    localStorage.setItem('user_added', 1)
                    // handleRedirectInternal(history, 'login')
                    handleLoginPopup()
                }
            } else if (responseStatusUser.from === 'userStatusUpdated') {
                localStorage.setItem('set_email', formikUser.values.email)
                localStorage.setItem('user_added', 1)
                setShowPopup(false)
                setDisable(false)
                // handleRedirectInternal(history, 'registration')
                handleRegisterPopup()
            }
        }
        clearResponseUser()
    }, [responseStatusUser])
    useEffect(() => {
        if (responseStatusAuth) {
            if (
                responseStatusAuth.status === 'success' &&
                responseStatusAuth.from !== 'checkValidation'
            ) {
                // handleRedirectInternal(history, '')
            } else if (
                responseStatusAuth.from === 'checkValidation' &&
                !responseStatusAuth.message.includes('UserName')
            ) {
                if (responseStatusAuth.status === 'success') {
                    if (responseStatusAuth?.data && responseStatusAuth?.data.status) {
                        if (responseStatusAuth?.data.status === 'email_unverified') {
                            changeUserStatus(
                                { email: formikUser.values.email, action: 'active' },
                                true,
                            )
                        } else {
                            localStorage.setItem('user_added', 1)
                            setShowPopup(false)
                            setDisable(false)
                            // handleRedirectInternal(history, 'login')
                            handleLoginPopup()
                        }
                    } else {
                        localStorage.setItem('set_email', formikUser.values.email)
                        localStorage.setItem('user_added', 1)
                        setShowPopup(false)
                        setDisable(false)
                        // handleRedirectInternal(history, 'registration')
                        //i don't know why i comment below,because unable to register
                        // handleRegisterPopup()
                    }
                }
                clearResponseAuth()
            }
        }
    }, [responseStatusAuth])
    const location = useLocation()
    const { pathname } = useLocation()

    // useEffect(() => {
    //     const checkUserStatus = async () => {
    //         if (isLoading) {
    //             return
    //         }

    //         if (!user?.id) {
    //             if (localStorage?.user_added) {
    //                 setShowPopup(false)
    //             } else {
    //                 resetUserForm()
    //             }
    //         } else {
    //             setShowPopup(false)
    //         }
    //     }

    //     checkUserStatus()
    // }, [user, localStorage?.user_added, pathname, isLoading])

    useEffect(() => {
        const checkUserStatus = async () => {
            if (isLoading) {
                return
            }

            if (!user?.id) {
                if (localStorage?.user_added) {
                    setShowPopup(false)
                } else {
                    setShowPopup(true)
                }
            } else {
                setShowPopup(false)
            }
            setIsUserLoaded(true)
        }

        checkUserStatus()
    }, [user, localStorage?.user_added, pathname, isLoading])

    // useEffect(() => {
    //     if (user !== undefined || user !== null) {
    //         setIsUserLoaded(false)
    //     }
    // }, [user])

    useEffect(() => {
        if (responseStatusPayment) {
            if (responseStatusPayment.from === 'payment') {
                if (responseStatusPayment.status === 'success') {
                    if (responseStatusPayment.data && responseStatusPayment.data.url) {
                        const newWindow = window.open(
                            responseStatusPayment.data.url,
                            '_self',
                            'noopener,noreferrer',
                        )
                        if (newWindow) newWindow.opener = null
                    }
                }
            }
        }
    }, [responseStatusPayment])

    // useEffect(() => {
    //     if (searchValue) {
    //         handleRedirectInternal(history, `search`)
    //     }
    // }, [searchValue])

    const onLogOut = () => {
        history.replace(window.location.pathname)
        sessionStorage.removeItem('checkedProducts')
        sessionStorage.removeItem('productSums')
        sessionStorage.removeItem('userModifiedChecks')
        localStorage.removeItem('upDatedLocation')
        // localStorage.getItem('locationUpdated')
        logout()
        setAlert('Logged out successfully', 'gold')
        setIsUserLoaded(false)
        localStorage.setItem('logout', '1')
        localStorage.removeItem('locationUpdated')
        localStorage.removeItem('user_added')

        // handleRedirectInternal(history, '')
        setanchormenu(null)
        setanchormenubar(null)
        setanchorcart(null)
        setSearchText('')
        toggleMenuDrawer()
        // handleLoginPopup()
    }
    const toggleMenuDrawer = () => setMenuDrawerOpen(!menuDrawerOpen)
    const toggleDrawer = (anchor, open) => (event) => {
        setState({ ...state, [anchor]: open })
    }

    const handleCart = (event) => {
        setanchorcart(event.currentTarget)
    }
    const handleMenu = (event) => {
        setanchormenu(event.currentTarget)
    }
    const handleMenuBar = (event) => {
        setanchormenubar(event.currentTarget)
    }

    const handleClose = (history, path) => {
        setanchormenu(null)
        setanchormenubar(null)
        setanchorcart(null)
        if (history && path && path !== 'backdropClick') {
            handleRedirectInternal(history, path)
        }
    }

    const getSearchBarObjet = (value) => {
        return {
            limit: 12,
            page: 1,
            orderby: 'p.id, desc',
            order: '',
            filters: {
                searchbar: {
                    value: value,
                    type: 'like',
                    field: 'p.title,p.desc_proc',
                },
            },
        }
    }

    const closePopup = () => {
        setShowPopup(!showPopup)
    }

    const handleSearchTextChange = (e) => {
        setSearchText(e.target.value)
    }

    const handleSearchButtonClick = () => {
        setSearchValue(getSearchBarObjet(searchText))
        setState({ ...state, top: false })
        if (location.pathname != '/search') {
            handleRedirectInternal(history, 'search')
        }
    }

    const handleSearchKeyDown = (e) => {
        if (e.key === 'Enter') {
            setSearchValue(getSearchBarObjet(searchText))
            if (location.pathname != '/search') {
                handleRedirectInternal(history, 'search')
            }
        }
    }

    const fileValidationArray = Yup.object({
        file_path: Yup.array().when('content_type', {
            is: 'file',
            then: Yup.array().required('Required!'),
        }),
    })
    const fileFormik = useFormik({
        initialValues: {
            file_path: [],
        },
        validationSchema: fileValidationArray,
        onSubmit: (values) => {},
    })

    const handleUpload = (data) => {
        setFileUploaded(data)
    }

    const fileUpload = {
        formik: fileFormik,
        data: [
            {
                type: 'uploadDropZone',
                name: 'file_path',
                icon: 'description',
                titleText: 'Upload Image',
                class: `col-12`,
                folder: 'product',
                multiple: false,
                getBlobUrl: handleUpload,
                webcam: true,
            },
        ],
    }

    // useEffect(() => {
    //     if (searchValue && searchValue.filters && searchValue.filters.searchbar) {
    //         setSearchText(searchValue.filters.searchbar.value)
    //     }
    // }, [searchValue])

    useEffect(() => {
        if (isAuthenticated) {
            loadPendingCount(buyNowFilter, 'buynowCount')
            loadPendingCount(watchlistFilter, 'watchlistCount')
            loadPendingCount(bidsFilter, 'bidsCount')
        }
    }, [isAuthenticated])

    useEffect(() => {
        const socket = openSocket(`${process.env.REACT_APP_DOMAIN}/`, {
            transports: ['websocket'],
        })
        socket.on('realclosedupdates', (data) => {
            if (parseInt(userRef?.current) === parseInt(data.bpop_cbidder)) {
                loadPendingCount(buyNowFilter, 'buynowCount')
                loadPendingCount(bidsFilter, 'bidsCount')
            }
        })
        socket.on('bidAddtime', (data) => {
            if (parseInt(userRef?.current) === parseInt(data.bpop_cbidder)) {
                loadPendingCount(bidsFilter, 'bidsCount')
            }
        })
        socket.on('restocking_fee_update', (data) => {
            if (data.user_id == userRef?.current) {
                sessionStorage.removeItem('checkedProducts')
                sessionStorage.removeItem('productSums')
                sessionStorage.removeItem('userModifiedChecks')
                loadUser()
            }
        })
        socket.on('refreshuser', (data) => {
            if (data?.id == userRef?.current) {
                loadUser()
            }
        })
        return () => {
            socket.off('realclosedupdates', (data) => {
                if (parseInt(userRef?.current) === parseInt(data.bpop_cbidder)) {
                    loadPendingCount(buyNowFilter, 'buynowCount')
                    loadPendingCount(bidsFilter, 'bidsCount')
                }
            })
            socket.off('bidAddtime', (data) => {
                if (parseInt(userRef?.current) === parseInt(data.bpop_cbidder)) {
                    loadPendingCount(bidsFilter, 'bidsCount')
                }
            })
            socket.off('restocking_fee_update', (data) => {
                if (data.user_id == userRef?.current) {
                    sessionStorage.removeItem('checkedProducts')
                    sessionStorage.removeItem('productSums')
                    sessionStorage.removeItem('userModifiedChecks')
                    loadUser()
                }
            })
            socket.off('refreshuser', (data) => {
                if (data?.id == userRef?.current) {
                    loadUser()
                }
            })
            socket.disconnect()
        }
    }, [])

    function refreshPage() {
        window.location.reload(false)
    }

    const [count, setCount] = useState({
        bidsCount: 0,
        buynowCount: 0,
        watchlistCount: 0,
    })

    const changeScanDialogStatus = () => {
        // fileFormik.resetForm()
        setScanToggle(!scanToggle)
    }

    const handleScanProduct = () => {
        setScanToggle(true)
    }

    useEffect(() => {
        if (cartCount?.bidsCount) {
            setCount({ ...count, bidsCount: cartCount.bidsCount.totalRecords })
        }
        if (cartCount?.buynowCount) {
            setCount({ ...count, buynowCount: cartCount.buynowCount.totalRecords })
        }
        if (cartCount?.watchlistCount) {
            setCount({ ...count, watchlistCount: cartCount.watchlistCount.totalRecords })
        }
    }, [cartCount])

    useEffect(() => {
        if (params.get('location')) {
            let locationQuery = params.get('location')
            if (locationQuery) {
                setSelectedValue(locationQuery)
            } else {
                setSelectedValue('')
            }
        } else {
            setSelectedValue('')
        }
    }, [params.get('location')])
    useEffect(() => {
        const paramsSearch = new URLSearchParams(window.location.search)
        const searchValue = paramsSearch.get('searchbar') // only check 'searchbar'

        if (!searchValue) {
            // If 'searchbar' is missing or empty
            setSearchText('')
        }
    }, [window?.location?.search])

    const generateQueryParams = (type, id) => {
        let queryObject = {}
        if (type === 'location') {
            queryObject.location = id
        } else if (type === 'search') {
            queryObject.searchbar = id
        }

        const params = new URLSearchParams(queryObject)
        return params.toString()
    }

    const handleSelectedValue = (event) => {
        setSelectedValue(event.target.value)
        let query = generateQueryParams('location', event.target.value)
        handleRedirectInternal(history, `search?${query}`)
    }

    useEffect(() => {
        if (fileFormik.values.file_path && fileFormik.values.file_path.length) {
            // setImageFile(`${global.site_url}/uploads/product/${fileFormik.values.file_path[0]}`)
            setImageFile(fileFormik.values.file_path[0])
        }
    }, [fileFormik.values.file_path])

    const convertImageUrlToBlob = (url, callback) => {
        const xhr = new XMLHttpRequest()
        xhr.open('GET', url, true)
        xhr.responseType = 'blob'

        xhr.onload = function () {
            if (xhr.status === 200) {
                callback(xhr.response)
            } else {
                console.error('Failed to fetch image:', xhr.statusText)
            }
        }

        xhr.onerror = function () {
            console.error('Network error occurred')
        }

        xhr.send()
    }

    const appId = process.env.REACT_APP_ALGOLIA_APPID
    const apiKey = process.env.REACT_APP_ALGOLIA_APIKEY
    const searchClient = algoliasearch(appId, apiKey)

    // const handleSearchAutocompleteTextChange = (item, reset) => {
    //     let searchQuery = reset ? '' : item.state.query

    //     setSearchText(item.state.query)
    //     if (searchQuery != '') {
    //         if (location.pathname !== '/search' || location.pathname !== '/') {
    //             let query = generateQueryParams('search', searchQuery)
    //             handleRedirectInternal(history, `search?${query}`)
    //         } else {
    //             setSearchValue(getSearchBarObjet(searchQuery))
    //         }
    //     } else {
    //         setSearchValue(getSearchBarObjet(searchQuery))
    //     }
    //     return true
    // }

    const handleSearchAutocompleteTextChange = (item, reset, event) => {
        let searchQuery = reset ? '' : item

        if (item == '' && event === 'Enter') {
            handleRedirectInternal(history, `search`)
            return true
        } else if (event === 'close') {
            setSearchText('')
            handleRedirectInternal(history, `search`)
            return true
        } else {
            setSearchText(item)
            let query = generateQueryParams('search', searchQuery)
            if (searchQuery !== '') {
                handleRedirectInternal(history, `search?${query}`)
            } else {
                handleRedirectInternal(history, ``)
            }
            return true
        }
    }
    const changePopupStatus = () => {
        setShowPopup(!showPopup)
    }

    const changeIntroPopupStatus = () => {
        setShowIntroPopup(!showIntroPopup)
        sessionStorage.setItem('showIntroPopup', !showIntroPopup ? 'true' : 'false')
    }

    useEffect(() => {
        if (
            responseStatusAuth &&
            (responseStatusAuth.message === 'Logged in successfully' ||
                responseStatusAuth.message === 'Successfully registered!')
        ) {
            sessionStorage.setItem('showIntroPopup', 'true')
            setShowIntroPopup(true)
        }
    }, [responseStatusAuth])

    const changeQrPopupStatus = () => {
        setQrCodePopup(!qrCodePopup)
    }

    const changeVideoPopupStatus = (link = '') => {
        setIsMuted(true)
        setVideoPopup(!videoPopup)
        setVideoLink(link)
    }

    const handleVideoClick = (link = '') => {
        setIsMuted(true)
        setVideoPopup(true)
        setVideoLink(link)
    }

    const validationUserArray = Yup.object({
        email: Yup.string().email('Invalid email format').max(250, 'Maximum 250 characters'),
        checkPopup: Yup.boolean().when('email', {
            is: (value) => !value,
            then: Yup.boolean().oneOf([true], 'Required!').required('Required!'),
        }),
    })

    const formikUser = useFormik({
        initialValues: {
            email: '',
            action: 'active',
            checkPopup: 0,
            importStatus: true,
        },
        validationSchema: validationUserArray,
        onSubmit: (values) => {
            if (values.email !== '') {
                changeUserStatus(values, true, 'userStatusUpdated')
                if (values.checkPopup) {
                    localStorage.setItem('user_added', 1)
                }
                setDisable(true)
            } else {
                if (values.checkPopup) {
                    localStorage.setItem('user_added', 1)
                }
                changePopupStatus()
                setDisable(false)
            }
        },
    })
    const resetUserForm = () => {
        formikUser.handleReset()
    }
    const UserUpdate = {
        formik: formikUser,
        data: [
            // {
            //     label: 'Email address' + '*',
            //     name: 'email',
            //     type: 'email',
            //     placeholder: 'Enter your email address',
            //     class: 'col-12 col-sm-12',
            // },
            {
                label: 'Don`t show this again',
                name: 'checkPopup',
                type: 'checkbox',
                placeholder: '',
                class: 'col-sm-6 col-12 auth-links-wrap termsCndtn m-auto',
            },
        ],
    }

    useEffect(() => {
        if (allHeaderMenus?.length) {
            setHeaderMenus(allHeaderMenus.filter((menu) => menu.type === 'header'))
        }
    }, [allHeaderMenus])

    const orderbyHeader = [
        { id: 18, label: "Today's Steals", href: 20 },
        { id: 21, label: 'Popular', href: 21 },
    ]

    const searchBarValue = params.get('searchbar')

    useEffect(() => {
        const queryParams = new URLSearchParams(window.location.search)
        if (queryParams.get('login') === 'true') {
            setShowPopup(false)
            handleLoginPopup()
        }
    }, [])

    return (
        <>
            {useCustomMediaQuery('(min-width: 1025px)') ? (
                <>
                    {/* DESKTOP NAVIGATION */}
                    <Loaders name="home" isLoading={isLoading} />
                    <header className="mainHeader noPrint">
                        <div
                            className={`customContainer d-flex justify-content-between align-items-center h-100 header-wrapper`}
                        >
                            <div className="headLt d-flex justify-content-start align-items-center">
                                <Link to="/" className="header-logo" id="header-logo">
                                    <img src={LOGO} alt={SITE_NAME} width="157" height="47" />
                                </Link>
                            </div>
                            <div className="custom-state-city">
                                <div style={{ paddingRight: '3px' }}>
                                    <img src="/assets/images/loaction_sn.png" alt="" />
                                </div>
                                <Button className="text-white" onClick={handleLocation}>
                                    {cityName !== '' ? cityName : locationName || 'Select Location'}
                                    <br />
                                    <span className="material-icons-outlined expand">
                                        expand_more
                                    </span>
                                </Button>
                                <LocationSelector
                                    openLocation={openLocation}
                                    pathname={location.pathname}
                                    setLocationName={setLocationName}
                                    setCityName={setCityName}
                                    handleLocation={handleLocation}
                                />
                            </div>
                            <div className="menuRtOtr menu-right">
                                <div className="headRt deskNav d-flex justify-content-end align-items-center">
                                    <div className="form-inline my-2 my-lg-0 headerSearchForm">
                                        {/* <ClickAwayListener onClickAway={handletoggleSearch}>
                                        <div className="form-inline my-2 my-lg-0 headerSearchForm">
                                            <Autocomplete
                                                value={searchText || searchBarValue}
                                                // placeholder={searchText || searchBarValue}
                                                open={openSearch}
                                                onOpen={handletoggleSearch}
                                                onClose={handletoggleSearch}
                                                openOnFocus={true}
                                                onSubmit={(stateData) => {
                                                    stateData.setIsOpen(false)
                                                    handleSearchAutocompleteTextChange(
                                                        stateData,
                                                        false,
                                                    )
                                                }}
                                                onKeyDown={(e) => {
                                                    console.log(e.target.value, 'value coming')
                                                }}
                                                getSources={({ query }) => [
                                                    {
                                                        sourceId: 'products',
                                                        onSelect({
                                                            setIsOpen,
                                                            setQuery,
                                                            event,
                                                            item,
                                                        }) {
                                                            window.open(
                                                                `/product-view/${item?.objectID}`,
                                                                '_blank',
                                                            )
                                                        },
                                                        getItems() {
                                                            return getAlgoliaResults({
                                                                searchClient,
                                                                queries: [
                                                                    {
                                                                        indexName:
                                                                            process.env
                                                                                .REACT_APP_ALGOLIA_INDEX,
                                                                        query,
                                                                        params: {
                                                                            // filters: query.trim()
                                                                            //     ? `title:"${query}"`
                                                                            //     : undefined,
                                                                            queryType: 'prefixNone',
                                                                        },
                                                                    },
                                                                ],
                                                            })
                                                        },

                                                        templates: {
                                                            header() {
                                                                return 'Suggestions'
                                                            },
                                                            item({ item, components }) {
                                                                return (
                                                                    <>
                                                                        {item?.objectID ? (
                                                                            <div className="aa-ItemTitle">
                                                                                <components.Highlight
                                                                                    hit={item}
                                                                                    attribute="title"
                                                                                />
                                                                            </div>
                                                                        ) : null}
                                                                    </>
                                                                )
                                                            },
                                                        },
                                                    },
                                                ]}
                                            />
                                        </div>
                                    </ClickAwayListener> */}
                                        <button
                                            onClick={() =>
                                                handleSearchAutocompleteTextChange(
                                                    searchText?.trim(),
                                                )
                                            }
                                            className="search-icon"
                                        >
                                            <img src="/assets/svg/search.svg" />
                                        </button>
                                        <input
                                            type="search"
                                            onChange={(e) => {
                                                setSearchText(e.target.value)
                                                if (
                                                    e?.target?.value === '' &&
                                                    e.nativeEvent.inputType === undefined
                                                ) {
                                                    let query = generateQueryParams('search', '')
                                                    handleRedirectInternal(history, `search`)
                                                }
                                            }}
                                            className="headerChSearch"
                                            onKeyDown={(e) => {
                                                if (e.key === 'Enter') {
                                                    if (searchText !== '') {
                                                        handleSearchAutocompleteTextChange(
                                                            searchText.trim(),
                                                        )
                                                    } else {
                                                        let query = generateQueryParams(
                                                            'search',
                                                            '',
                                                        )
                                                        handleRedirectInternal(history, `search`)
                                                    }
                                                }
                                            }}
                                            value={searchText || ''}
                                        />
                                        <button
                                            onClick={() => handleScanProduct()}
                                            className="barcode-scanner"
                                        >
                                            <span className="material-icons">qr_code_scanner</span>
                                        </button>
                                        {/* <button
                                            onClick={() => {
                                                setSearchText('')
                                                handleSearchAutocompleteTextChange('', 1)
                                            }}
                                            className="clear-icon"
                                        >
                                            <img src="/assets/svg/closeIcon.svg" />
                                        </button> */}
                                    </div>
                                    <ul className="d-flex justify-content-start align-items-center">
                                        {isAuthenticated ? (
                                            <>
                                                <li>
                                                    <Button
                                                        id="header_user_detail"
                                                        aria-controls="simple-menu"
                                                        aria-haspopup="true"
                                                        onClick={toggleMenuDrawer}
                                                    >
                                                        Hi, {user?.first_name}
                                                    </Button>
                                                </li>
                                            </>
                                        ) : (
                                            <>
                                                <li className="authDiff">
                                                    <NavLink
                                                        to="#"
                                                        onClick={handleLoginPopup}
                                                        ActiveclassName="active"
                                                        id="header_login"
                                                    >
                                                        Login
                                                    </NavLink>
                                                    <span className="position-relative slash"></span>
                                                    <NavLink
                                                        to="#"
                                                        onClick={handleRegisterPopup}
                                                        ActiveclassName="active"
                                                        id="header_register"
                                                    >
                                                        Register
                                                    </NavLink>
                                                </li>
                                            </>
                                        )}
                                        {isAuthenticated ? (
                                            <>
                                                <li>
                                                    <Button
                                                        onClick={() => setQrCodePopup(true)}
                                                        id="header_cart"
                                                    >
                                                        <Badge color="primary">
                                                            <img
                                                                src="/assets/svg/qr-code.svg"
                                                                alt=""
                                                                style={{ width: '26px' }}
                                                            />
                                                        </Badge>
                                                    </Button>
                                                </li>
                                                <li>
                                                    <Button
                                                        onClick={() =>
                                                            handleRedirectInternal(history, 'cart')
                                                        }
                                                        id="header_cart"
                                                    >
                                                        <Badge
                                                            badgeContent={count?.buynowCount || 0}
                                                            color="primary"
                                                        >
                                                            <img
                                                                src="/assets/svg/shopping-cart.svg"
                                                                alt=""
                                                            />
                                                        </Badge>
                                                    </Button>
                                                </li>
                                            </>
                                        ) : (
                                            ''
                                        )}
                                        <li>
                                            <Button
                                                onClick={toggleMenuDrawer}
                                                type="button"
                                                className="af-btn"
                                            >
                                                <span className="material-icons">menu</span>
                                            </Button>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                        <Nav
                            menuClass={`${
                                // window.location.pathname == '/search'
                                //     ? 'container-fluid'
                                // :
                                'customContainer'
                            }`}
                        >
                            {/* {isAuthenticated && (
                                <>
                                    {authList.map((list) => (
                                        <NavLink
                                            key={`nav-${list.label}`}
                                            to={list.href}
                                            anchor={true}
                                        >
                                            {list.label}
                                        </NavLink>
                                    ))}
                                </>
                            )} */}
                            {/* {menuList.map((list) => (
                                <>
                                    <NavLink key={`nav-${list.label}`} to={list.href}>
                                        {list.label}
                                    </NavLink>
                                </>
                            ))} */}
                            <NavLink
                                key={`nav-Seach Page`}
                                to={'/search'}
                                onClick={() => handleListSearch()}
                            >
                                All Listings
                            </NavLink>

                            {orderbyHeader.map((item) => (
                                <>
                                    <NavLink
                                        key={`nav-${item.id}`}
                                        to={`/search?orderby=${item.href}`}
                                    >
                                        {item.label}
                                    </NavLink>
                                </>
                            ))}

                            {headerMenus?.map((list) => (
                                <>
                                    {list?.type === 'header' ? (
                                        list.menu_type === 'tag' ? (
                                            <NavLink
                                                key={`nav-${list.id}`}
                                                to={`/search?keywords=${list?.menu_value || ''}`}
                                            >
                                                {list.menu_name}
                                            </NavLink>
                                        ) : (
                                            <a
                                                key={`nav-${list.id}`}
                                                href={`${list?.menu_value || '#'}`}
                                            >
                                                {list.menu_name}
                                            </a>
                                        )
                                    ) : null}
                                </>
                            ))}

                            <NavLink key={`nav-Locations Map`} to={'/locationmap'}>
                                locations Map
                            </NavLink>
                        </Nav>
                    </header>
                    {socketDisconnect && (
                        <p className="network-issue">
                            Network has been disconnected trying to reconnect... or click here to{' '}
                            <span
                                onClick={() => window.location.reload(0)}
                                className="network-reload"
                            >
                                reload
                            </span>
                        </p>
                    )}
                </>
            ) : (
                <MobileHeader
                    locationValue={selectedValue}
                    locationData={locationData}
                    searchTextDesk={searchText}
                    handleLocationValue={handleSelectedValue}
                    handleSearchAutocompleteTextChange={handleSearchAutocompleteTextChange}
                    handleScanProduct={handleScanProduct}
                />
            )}
            <BarCodeScan
                scanToggle={scanToggle}
                changeScanDialogStatus={changeScanDialogStatus}
                setDecodedBarcode={setDecodedBarcode}
            />
            <BidHistory />
            <CustomDrawer
                toggleDrawer={toggleMenuDrawer}
                anchor="right"
                open={menuDrawerOpen}
                className="custom-drawer menu-drawer search-filter-drawer"
            >
                <ul>
                    <ListItem
                        button
                        onClick={
                            isAuthenticated
                                ? () => {
                                      handleClose(history, 'my-account')
                                      toggleMenuDrawer()
                                  }
                                : handleLoginPopup
                        }
                    >
                        <span className="material-icons">person</span>
                        {'Account'}
                    </ListItem>
                    <ListItem
                        button
                        onClick={
                            isAuthenticated
                                ? () => {
                                      handleClose(history, 'my-orders')
                                      toggleMenuDrawer()
                                  }
                                : handleLoginPopup
                        }
                    >
                        <span className="material-icons">assignment_return</span>
                        {'Orders & Returns'}
                    </ListItem>
                    <ListItem
                        button
                        onClick={
                            isAuthenticated
                                ? () => {
                                      handleClose(history, 'favorites/watchlist')
                                      toggleMenuDrawer()
                                  }
                                : handleLoginPopup
                        }
                    >
                        <span className="material-icons">favorite</span>
                        {'Favorites'}
                    </ListItem>
                    <ListItem
                        button
                        onClick={
                            isAuthenticated
                                ? () => {
                                      handleClose(history, 'offers/allactive')
                                      toggleMenuDrawer()
                                  }
                                : handleLoginPopup
                        }
                    >
                        <span className="material-icons">sell</span>
                        {'Offers'}
                    </ListItem>
                    <ListItem
                        button
                        onClick={
                            isAuthenticated
                                ? () => {
                                      handleRedirectInternal(history, 'cart')
                                      toggleMenuDrawer()
                                  }
                                : handleLoginPopup
                        }
                    >
                        <span className="material-icons">shopping_cart</span>
                        {'Cart'}
                    </ListItem>
                    {/* <ListItem onClick={isAuthenticated ? '' : handleLoginPopup}>
                        <span className="material-icons">preview</span>
                        {'Recently Viewed'}
                    </ListItem> */}
                    <ListItem
                        button
                        onClick={
                            isAuthenticated
                                ? () => {
                                      handleRedirectInternal(history, 'wallet')
                                      toggleMenuDrawer()
                                  }
                                : handleLoginPopup
                        }
                    >
                        <span className="material-icons">account_balance_wallet</span>
                        {'Manage Credits'}
                    </ListItem>
                    <ListItem
                        button
                        onClick={
                            isAuthenticated
                                ? () => {
                                      handleRedirectInternal(history, 'payments/saved_cards')
                                      toggleMenuDrawer()
                                  }
                                : handleLoginPopup
                        }
                    >
                        <span className="material-icons">credit_card</span>
                        {'Manage Cards'}
                    </ListItem>
                    <ListItem
                        button
                        onClick={
                            isAuthenticated
                                ? () => {
                                      handleRedirectInternal(history, 'my-account/password')
                                      toggleMenuDrawer()
                                  }
                                : handleLoginPopup
                        }
                    >
                        <span className="material-icons">verified_user</span>
                        {'Account Security'}
                    </ListItem>
                    <ListItem
                        button
                        onClick={
                            isAuthenticated
                                ? () => {
                                      handleRedirectInternal(history, 'my-account/personal')
                                      toggleMenuDrawer()
                                  }
                                : handleLoginPopup
                        }
                    >
                        <span className="material-icons">info</span>
                        {'Personal Information'}
                    </ListItem>
                    {/* <ListItem onClick={isAuthenticated ? '' : handleLoginPopup}>
                        <span className="material-icons">campaign</span>
                        {'Announcements'}
                    </ListItem> */}
                    <ListItem
                        button
                        onClick={
                            isAuthenticated
                                ? () => {
                                      handleRedirectInternal(history, 'my-account/notifications')
                                      toggleMenuDrawer()
                                  }
                                : handleLoginPopup
                        }
                    >
                        <span className="material-icons">forum</span>
                        {'Preferences'}
                    </ListItem>
                    <ListItem
                        button
                        onClick={
                            isAuthenticated
                                ? () => {
                                      handleRedirectInternal(history, 'my-account/saved_search')
                                      toggleMenuDrawer()
                                  }
                                : handleLoginPopup
                        }
                    >
                        <span className="material-icons">saved_search</span>
                        {'Saved Search'}
                    </ListItem>
                    <ListItem
                        button
                        onClick={
                            isAuthenticated
                                ? () => {
                                      handleRedirectInternal(history, 'my-account/my-interests')
                                      toggleMenuDrawer()
                                  }
                                : handleLoginPopup
                        }
                    >
                        <span className="material-icons">interests</span>
                        {'Interests'}
                    </ListItem>
                    <ListItem
                        button
                        onClick={() => {
                            handleRedirectInternal(history, 'contact-us')
                        }}
                    >
                        <span className="material-icons">contact_support</span>
                        {'Contact Us'}
                    </ListItem>
                    {/* <ListItem
                        button
                        onClick={() => handleRedirectInternal(history, 'schedule/pending')}
                    >
                        {'Schedule Pickup'}
                    </ListItem> */}

                    {isAuthenticated && (
                        <ListItem
                            button
                            onClick={() => {
                                onLogOut()
                                toggleMenuDrawer()
                            }}
                            id="header_logout"
                        >
                            <span className="material-icons">logout</span>
                            Logout
                        </ListItem>
                    )}
                </ul>
            </CustomDrawer>
            {pathname == '/' && isUserLoaded && showPopup && !loginPopup && (
                <CustomDialog
                    open={showPopup}
                    function={changePopupStatus}
                    className="ladingModal"
                    closeBtnCustomHeight="14"
                    closeBtnCustomWidth="14"
                    colorCode="#000000"
                >
                    <h4 className="landingRootTit">Zipperbuy</h4>
                    <h4 className="landingsubTit">
                        Buy outside the box
                        <img src="/assets/images/outBox.png" alt="OutofBox" />
                    </h4>
                    <p className="landingPara">
                        We&apos;ve made some changes and updates, so feel free to watch the videos
                        below to see what&apos;s new!
                    </p>
                    <div className="videoBoxContainer">
                        <div className="listBoxRoot">
                            <p
                                className="videoTit"
                                onClick={() =>
                                    handleVideoClick(
                                        allConfigurationVariables?.initial_popup_quick_tour_video ||
                                            'https://www.youtube.com/watch?v=OIdExntO-jw',
                                    )
                                }
                                style={{ cursor: 'pointer' }}
                            >
                                Quick Tour
                            </p>
                            <img
                                src="/assets/images/homeOne.png"
                                alt="video"
                                className="img"
                                onClick={() =>
                                    handleVideoClick(
                                        allConfigurationVariables?.initial_popup_quick_tour_video ||
                                            'https://www.youtube.com/watch?v=OIdExntO-jw',
                                    )
                                }
                                style={{ cursor: 'pointer' }}
                            />
                        </div>
                        <div className="listBoxRoot">
                            <p
                                className="videoTit"
                                onClick={() =>
                                    handleVideoClick(
                                        allConfigurationVariables?.initial_popup_offer_or_buynow_video ||
                                            'https://www.youtube.com/watch?v=OIdExntO-jw',
                                    )
                                }
                                style={{ cursor: 'pointer' }}
                            >
                                Offer or Buy Now
                            </p>
                            <img
                                src="/assets/images/homeTwo.png"
                                alt="video"
                                className="img"
                                onClick={() =>
                                    handleVideoClick(
                                        allConfigurationVariables?.initial_popup_offer_or_buynow_video ||
                                            'https://www.youtube.com/watch?v=OIdExntO-jw',
                                    )
                                }
                                style={{ cursor: 'pointer' }}
                            />
                        </div>
                        <div className="listBoxRoot">
                            <p
                                className="videoTit"
                                onClick={() =>
                                    handleVideoClick(
                                        allConfigurationVariables?.initial_popup_your_account_video ||
                                            'https://www.youtube.com/watch?v=OIdExntO-jw',
                                    )
                                }
                                style={{ cursor: 'pointer' }}
                            >
                                Your Account
                            </p>
                            <img
                                src="/assets/images/homeThree.png"
                                alt="video"
                                className="img"
                                onClick={() =>
                                    handleVideoClick(
                                        allConfigurationVariables?.initial_popup_your_account_video ||
                                            'https://www.youtube.com/watch?v=OIdExntO-jw',
                                    )
                                }
                                style={{ cursor: 'pointer' }}
                            />
                        </div>
                    </div>
                    {/* <form onClick={formikUser.handleSubmit}>{mapData(UserUpdate)}</form> */}
                    <div className="landingConclud">
                        <p className="info">Existing & New Users</p>
                        <Link
                            to="#"
                            onClick={() => {
                                changePopupStatus()
                                handleRegisterPopup()
                            }}
                            className="linkToRD"
                        >
                            Create Your Account
                        </Link>
                    </div>
                </CustomDialog>
            )}
            {/* <CustomDialog
                title="Website has been updated"
                open={showPopup}
                disableBackdropClick
                function={changePopupStatus}
            >
                <h5>{`We've updated the website for a smoother User Experience`}</h5>
                <h6>Please update your email address</h6>

                <form className="trmActnWrpr">
                    <div className="row mb-4">
                        {mapData(UserUpdate)}
                        <div className="col-sm-6 col-12">
                            <PrimaryButton
                                onClick={formikUser.handleSubmit}
                                id="user_update"
                                type="button"
                                disabled={disable}
                                label={'Submit'}
                            />
                        </div>
                    </div>
                </form>
                <h6>What you need to do:</h6>
                <p>All Bidder Numbers will remain the same</p>
                <p>
                    <b className="re-regs-text">
                        When you first log into the new system with your email, you will be required
                        to <span className="text-danger">Re-register</span> and update your profile
                        including password
                    </b>
                </p>
                <p>
                    For previous bidders receipts/invoices contact{' '}
                    <a
                        href={
                            configVariables && configVariables.admin_email
                                ? configVariables.admin_email
                                : 'support@zipperbuy.com'
                        }
                    >
                        {configVariables && configVariables.admin_email
                            ? configVariables.admin_email
                            : 'support@zipperbuy.com'}
                    </a>
                </p>
                <p>
                    For Reference :
                    <a
                        href={
                            configVariables && configVariables.popup_video_link
                                ? configVariables.popup_video_link
                                : 'support@zipperbuy.com'
                        }
                        target="_blank"
                        rel="noreferrer"
                    >
                        {configVariables && configVariables.popup_video_link
                            ? configVariables.popup_video_link
                            : 'support@zipperbuy.com'}
                    </a>
                </p>
            </CustomDialog> */}
            <Dialog open={loginPopup} function={handleLoginPopup} className="lgnWrpr loginPopup">
                <div className="lgnCntnr">
                    {/* <IconButton className="popClrBtn" onClick={handleLoginPopup}>
                        <span className="material-icons">clear</span>
                    </IconButton> */}
                    <Login />
                </div>
            </Dialog>
            <Dialog
                open={registerPopup}
                function={handleRegisterPopup}
                className="lgnWrpr registerPop loginPopup"
            >
                <div className="lgnCntnr">
                    {/* <IconButton className="popClrBtn" onClick={handleLoginPopup}>
                        <span className="material-icons">clear</span>
                    </IconButton> */}
                    <Registration />
                </div>
            </Dialog>
            <Dialog
                open={forgotPasswordPopup}
                function={handleForgotPasswordPopup}
                className="lgnWrpr registerPop loginPopup"
            >
                <div className="lgnCntnr">
                    <ForgotPassword />
                </div>
            </Dialog>
            <CustomDialog
                title="Membership QR"
                open={qrCodePopup}
                disableBackdropClick
                function={changeQrPopupStatus}
                className="qrAccount"
            >
                <div className="d-flex align-items-center accProf mb-4 justify-content-around">
                    <div className="userAvatarProfile">
                        {user?.avatar ? (
                            <span className="userInitials large">
                                <img
                                    src={`${global.site_url}/uploads/avatar/${user?.avatar}`}
                                    alt="userProfile"
                                />
                                {/* {user?.first_name?.charAt(0)}
                                {user?.last_name?.charAt(0)} */}
                            </span>
                        ) : (
                            <span className="material-icons">person</span>
                        )}
                    </div>
                    <div className="userName">
                        <h1>
                            {user?.first_name} {user?.last_name}
                        </h1>
                        <small>{user?.username}</small>
                    </div>
                </div>
                <QRCode value={user?.email?.toString() || user?.username?.toString() || ''} />
                <Link to="/" className="header-logo" id="header-logo">
                    <img src={LOGO} alt={SITE_NAME} width="157" height="47" />
                </Link>
            </CustomDialog>
            <CustomDialog
                open={videoPopup}
                function={changeVideoPopupStatus}
                className="videoPopup"
            >
                <div style={{ position: 'relative', paddingTop: '56.25%' }}>
                    <ReactPlayer
                        url={videoLink}
                        width="100%"
                        height="100%"
                        playing={videoPopup}
                        controls={true}
                        muted={isMuted}
                        playsinline
                        pip={false}
                        loop={false}
                        config={{
                            youtube: {
                                playerVars: {
                                    autoplay: 1,
                                    hd: 1,
                                    showinfo: 0,
                                    rel: 0,
                                    modestbranding: 1,
                                    iv_load_policy: 3,
                                    cc_load_policy: 0,
                                    fs: 1,
                                    disablekb: 0,
                                    autohide: 1,
                                    controls: 1,
                                    quality: 'highres',
                                },
                            },
                        }}
                        style={{
                            position: 'absolute',
                            top: 0,
                            left: 0,
                        }}
                    />
                </div>
                {isMuted && (
                    <button
                        onClick={() => setIsMuted(false)}
                        style={{
                            position: 'absolute',
                            bottom: 20,
                            left: 20,
                            background: 'rgba(0,0,0,0.5)',
                            color: 'white',
                            padding: '6px 12px',
                            border: 'none',
                            borderRadius: 4,
                        }}
                    >
                        🔊 Tap to unmute
                    </button>
                )}
            </CustomDialog>

            <CustomDialog
                title={'Connection Disrupted'}
                open={toggleDisconnectDialog}
                disableBackdropClick={true}
                function={(event, reason) => {
                    if (reason !== 'backdropClick') {
                        changeDisconnectDialogStatus()
                    }
                }}
                // function={changeDisconnectDialogStatus}
            >
                <h5>It appears that your connection has been disrupted.</h5>
                <h5>Please click the Reload button or refresh your browser.</h5>

                <div className="actionWrapper">
                    <PrimaryButton type="button" onClick={() => refreshPage()} label="RELOAD" />
                </div>
            </CustomDialog>
        </>
    )
}
export default Header
